import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./EventTimeline.module.css";

const EventTimeline = () => {
  const events = [
    {
      year: "2025",
      theme: "Seaside Citadel",
      description:
        " The theme of TEDxIITGuwahati 2025 is Seaside Citadel, which explores the beauty of creation in the face of impermanence.",
      image:
        "./images/eventsHome/theme25.png",
      link: "/Events/2025",
    },
    {
      year: "2024",
      theme: "Echoes of Stillness",
      description:
        " The theme for TEDxIITGuwahati 2024 is Echoes of Stillness.What’s that? It’s about fathoming the importance of taking break in process of reaching our goals.",
      image:
        "./images/eventsHome/theme24.jpg",
      link: "/Events/2024",
    },
    {
      year: "2023",
      theme: "The Silent Letter",
      description:
        "The Theme of TEDxIITGuwahati is ‘The Silent Letter’,Everything has value, whether good or bad, large or small.Nothing in this world is useless, although we often mistake that for the case.",
      image:
        "./images/eventsHome/theme_23.png",
      link: "/Events/2023",
    },
    {
      year: "2022",
      theme: "The Boiling Frog",
      description:
        "As the tale goes, if you put a frog in a pan of boiling water, it will jump out at once. However, if you place it in a pot of gently lukewarm water and slowly heat it, the frog stay in the water until it boils to death.",
      image:
        "./images/eventsHome/theme22.jpeg",
      link: "/Events/2022",
    },
    {
      year: "2021",
      theme: "The Other End of the Line",
      description:
        "Humans have always had an unexplainable drive to excel in aspect of life. As we leap across these barriers, do we take into consideration, a backup to cover the consequences of the mess we have regretfully created?",
      image:
        "./images/eventsHome/theme21.png",
      link: "/Events/2021",
    },
    {
      year: "2019",
      theme: "The Changing Faces of Taboo",
      description:
        "The words ‘rigid rules of yesterday that have become obscure and obsolete today’ describes precisely what the global society is incessantly countering with innumerable questions and logic.",
      image:
        "./images/eventsHome/theme19.png",
      link: "/Events/2019",
    },
    {
      year: "2016",
      theme: "Pushing the limits",
      description:
        "It is about the people who are doing the job for the betterment of society with little resources in the beginning and our aim is to give them a platform to share and spread their work to the world community.",
      image:
        "./images/eventsHome/theme16.png",
      link: "/Events/2016",
    },
  ];

  const [hoveredCard, setHoveredCard] = React.useState(null);
  const [isMobile, setIsMobile] = React.useState(false);
  const [cardHeights, setCardHeights] = React.useState({});
  const cardRefs = React.useRef({});

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);

      const heights = {};
      Object.keys(cardRefs.current).forEach((key) => {
        if (cardRefs.current[key]) {
          heights[key] = cardRefs.current[key].offsetHeight;
        }
      });
      setCardHeights(heights);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 100);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    return (
      <div className={styles.container}>
        <div className={styles.heading}>
          <h1>Some of our Events</h1>
        </div>
        <div className={styles.wrapperMobile}>
          {events.map((event, index) => (
            <div key={index} className={styles.mobileRow}>
              <div className={styles.yearDotMobile}>{event.year}</div>

              <div className={styles.mobileCardWrapper}>
                {/* ONLY CHANGE: wrap card with NavLink */}
                <NavLink
                  to={event.link}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    className={`${styles.card} ${
                      hoveredCard === index ? styles.cardHover : ""
                    }`}
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <img
                      src={event.image}
                      alt={event.theme}
                      className={styles.cardImage}
                    />
                    <div className={styles.cardContent}>
                      <h3 className={styles.cardTheme}>{event.theme}</h3>
                      <p className={styles.cardDescription}>
                        {event.description}
                      </p>
                    </div>
                  </div>
                </NavLink>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}><h1>Some of our Events</h1></div>
      <div className={styles.wrapperDesktop}>
        <div className={styles.centerTimeline} />
        <div className={`${styles.glowDot} ${styles.glowDotTop}`} />
        <div className={`${styles.glowDot} ${styles.glowDotBottom}`} />

        <div className={styles.contentWrapper}>
          {events.map((event, index) => {
            const isLeft = index % 2 === 0;
            const isLastItem = index === events.length - 1;
            const cardHeight = cardHeights[index] || 400;
            const yearDotTop = cardHeight / 2 - 27.5;

            return (
              <div
                key={index}
                className={`${styles.timelineRow} ${
                  isLastItem ? styles.lastItem : ""
                }`}
              >
                <div className={styles.leftSide}>
                  {isLeft && (
                    <>
                      <div
                        className={styles.yearDotWrapper}
                        style={{ top: `${yearDotTop}px` }}
                      >
                        <div className={styles.yearDot}>{event.year}</div>
                      </div>

                      {/* ONLY CHANGE: wrap card with NavLink */}
                      <NavLink
                        to={event.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <div
                          ref={(el) => (cardRefs.current[index] = el)}
                          className={`${styles.card} ${
                            hoveredCard === index ? styles.cardHover : ""
                          }`}
                          onMouseEnter={() => setHoveredCard(index)}
                          onMouseLeave={() => setHoveredCard(null)}
                        >
                          <img
                            src={event.image}
                            alt={event.theme}
                            className={styles.cardImage}
                          />
                          <div className={styles.cardContent}>
                            <h3 className={styles.cardTheme}>{event.theme}</h3>
                            <p className={styles.cardDescription}>
                              {event.description}
                            </p>
                          </div>
                        </div>
                      </NavLink>
                    </>
                  )}
                </div>

                <div className={styles.rightSide}>
                  {!isLeft && (
                    <>
                      <div
                        className={styles.yearDotWrapper}
                        style={{ top: `${yearDotTop}px` }}
                      >
                        <div className={styles.yearDot}>{event.year}</div>
                      </div>

                      {/* ONLY CHANGE: wrap card with NavLink */}
                      <NavLink
                        to={event.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <div
                          ref={(el) => (cardRefs.current[index] = el)}
                          className={`${styles.card} ${
                            hoveredCard === index ? styles.cardHover : ""
                          }`}
                          onMouseEnter={() => setHoveredCard(index)}
                          onMouseLeave={() => setHoveredCard(null)}
                        >
                          <img
                            src={event.image}
                            alt={event.theme}
                            className={styles.cardImage}
                          />
                          <div className={styles.cardContent}>
                            <h3 className={styles.cardTheme}>{event.theme}</h3>
                            <p className={styles.cardDescription}>
                              {event.description}
                            </p>
                          </div>
                        </div>
                      </NavLink>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EventTimeline;
